import { render } from "./StarChartSurvey.vue?vue&type=template&id=6a300a9a&scoped=true"
import script from "./StarChartSurvey.vue?vue&type=script&lang=js"
export * from "./StarChartSurvey.vue?vue&type=script&lang=js"

import "./StarChartSurvey.vue?vue&type=style&index=0&id=6a300a9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a300a9a"]])

export default __exports__